<h2>{{ 'careCompany.title' | cxTranslate }}</h2>
{{ 'careCompany.test' | cxTranslate }}

<div class="background-grey">
  <div class="container background-white">
    @if (user$ | async; as user) {
      @if (user.professional) {
        <div class="row justify-content-center">
          <form #frm [formGroup]="attentionCompanyForm" (submit)="submitForm()" class="row w-75">
            <div class="col-md-12">
              <p class="subtitle">{{ 'careCompany.subtitle' | cxTranslate }}</p>
            </div>
            @if (categories$ | async; as category) {
              <div class="form-group col-md-12">
                <label class="select-label">
                  <span class="label-content mandatory">{{ 'careCompany.subject' | cxTranslate }}</span>
                  <select formControlName="attentionCompanyType" class="form-control filter-select" (change)="changeSubjectType($event)">
                    <option selected value="" disabled>
                      {{ 'careCompany.type' | cxTranslate }}
                    </option>
                    @for (type of category.entities?.value?.attentionCompanies; track type) {
                      <option [value]="type.code">
                        {{ type.name }}
                      </option>
                    }
                  </select>
                  <!--                  <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>-->
                  <cx-form-errors [control]="attentionCompanyForm.get('attentionCompanyType')"></cx-form-errors>
                </label>
              </div>
            }
            @if (isFormVisible) {
              <div class="form-group col-md-6">
                <label>
                  <span class="label-content mandatory">{{ 'careCompany.companyName' | cxTranslate }}</span>
                  <input class="form-control" type="text" formControlName="companyName" />
                  <cx-form-errors [control]="attentionCompanyForm.get('companyName')"></cx-form-errors>
                </label>
              </div>
              <div class="form-group col-md-6">
                <label>
                  <span class="label-content mandatory">{{ 'careCompany.fullName' | cxTranslate }}</span>
                  <input class="form-control" type="text" formControlName="fullName" />
                  <cx-form-errors [control]="attentionCompanyForm.get('fullName')"></cx-form-errors>
                </label>
              </div>
              <div class="form-group col-md-6">
                <label>
                  <span class="label-content mandatory">{{ 'careCompany.email' | cxTranslate }}</span>
                  <input class="form-control" type="text" formControlName="email" />
                  <cx-form-errors [control]="attentionCompanyForm.get('email')"></cx-form-errors>
                </label>
              </div>
              <div class="form-group col-md-6">
                <label>
                  <span class="label-content mandatory">{{ 'careCompany.phone' | cxTranslate }}</span>
                  <input class="form-control" type="text" formControlName="phone" />
                  <cx-form-errors [control]="attentionCompanyForm.get('phone')"></cx-form-errors>
                </label>
              </div>
              @if (isRegionVisible) {
                <div class="form-group col-md-12">
                  <label class="select-label">
                    <span class="label-content mandatory">{{ 'register.region' | cxTranslate }}</span>
                    <select formControlName="region" class="form-control filter-select">
                      <option selected value="" disabled>
                        {{ 'careCompany.region' | cxTranslate }}
                      </option>
                      @for (region of regions$ | async; track region) {
                        <option [value]="region.isocode">
                          {{ region.name }}
                        </option>
                      }
                    </select>
                    <app-custom-icons [type]="iconTypes.ARROW_DOWN_ICON"></app-custom-icons>
                    <cx-form-errors [control]="attentionCompanyForm.get('region')"></cx-form-errors>
                  </label>
                </div>
              }
              <div class="form-group col-md-12">
                <label>
                  <span class="label-content mandatory">{{ 'careCompany.description' | cxTranslate }}</span>
                  <textarea class="form-control" placeholder="{{ 'careCompany.descriptionPlaceholder' | cxTranslate }}" formControlName="message"></textarea>
                  <cx-form-errors [control]="attentionCompanyForm.get('message')"></cx-form-errors>
                </label>
              </div>
              <div class="col-md-12">
                <p class="info-text">
                  <span [innerHTML]="'forms.careCompany.basicInfoPrivacy' | cxTranslate"></span>
                  <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">{{ 'contactUs.privacyTerms' | cxTranslate }}</a>
                </p>
              </div>
              <div class="form-group col-md-5 checkfield">
                <div class="form-check keep-in-session">
                  <label class="checkbox">
                    <input type="checkbox" formControlName="privacyPolicy" />
                    <span class="form-check-label info-text mandatory">
                      <span [innerHTML]="'forms.contactUs.termsAndConditions' | cxTranslate"></span>
                      <a [routerLink]="{ cxRoute: 'termsAndConditions' } | cxUrl" documentType="_blank">
                        {{ 'contactUs.termsAndConditions2' | cxTranslate }}
                      </a>
                    </span>
                  </label>
                </div>
                <cx-form-errors [control]="attentionCompanyForm.get('privacyPolicy')"></cx-form-errors>
              </div>
              <div class="row col-md-12 m-0">
                <button class="btn btn-block btn-black col-md-5" type="submit" [disabled]="submitted$ | async">
                  {{ 'careCompany.send' | cxTranslate }}
                </button>
              </div>
            }
          </form>
        </div>
      } @else {
        <div class="row justify-content-around">
          <p>{{ 'careCompany.notRegisteredDescription' | cxTranslate }}</p>
          <a [routerLink]="{ cxRoute: 'register' } | cxUrl" class="btn btn-white">
            {{ 'careCompany.notRegisteredButton' | cxTranslate }}
          </a>
        </div>
      }
    } @else {
      <div class="col-sm-12 row pt-5 pb-5 container">
        <div class="col-sm-6 border-right-dark pr-5">
          <h3>{{ 'careCompany.notRegistered' | cxTranslate }}</h3>
          <p>{{ 'careCompany.notRegisteredDescription' | cxTranslate }}</p>
          <a [routerLink]="{ cxRoute: 'register' } | cxUrl" class="btn btn-white notRegisteredBtn">
            {{ 'careCompany.notRegisteredButton' | cxTranslate }}
          </a>
        </div>
        <div class="col-sm-6 pl-5 registered">
          <h3>{{ 'careCompany.registered' | cxTranslate }}</h3>
          <p>{{ 'careCompany.registeredText' | cxTranslate }}</p>
          <app-custom-login-form></app-custom-login-form>
        </div>
      </div>
    }
  </div>
</div>
